import React from 'react'
import { Field, reduxForm } from 'redux-form'
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import CustomCheckBox from '../../component/onlineServices/CustomCheckBox';
import Captcha from './Captcha';
import SubmissionErrorNotice from './SubmissionErrorNotice';
import SubmissionButtonContent from './SubmissionButtonContent';
import { validateIdentity } from '../../apis/leadValidation';
import './Contact.css';

function validate(values) {
    const errors = validateIdentity(values);
    if (!values.subject || values.subject.trim().length < 3 || values.subject.trim().length > 100) errors.subject = 'Zadejte předmět (3–100 znaků).';
    if (values.message && values.message.length > 2000) errors.message = 'Zpráva nesmí přesáhnout 2 000 znaků.';
    return errors;
}



function renderField({ input, customAS, label, customRows, type, placeholder, meta: { touched, error } }){
 
      return(
          <>
            <Form.Label>{label}</Form.Label>
            <Form.Control  {...input} 
            placeholder={placeholder} 
            type={type}
            as={customAS === null? null : customAS}
            rows={customRows === null? null : customRows}
            isInvalid={touched && error}
            isValid={touched && !error}
            />
            <Form.Control.Feedback type="invalid">
                  {error}
              </Form.Control.Feedback>
          </>
      );
  }
var MainContactForm = (props) =>{

    const { handleSubmit, submitting, error } = props;


    function handleFormSubmit(formValues){
        return props.handleFormSubmit(formValues);
    }
 
    return (
        <Form noValidate onSubmit={handleSubmit(handleFormSubmit)}>
                <SubmissionErrorNotice message={error} />
                <Form.Group className="space-bottom">
                    <Row>
                        <Col>
                            <Field name="firstName" type="text" component={renderField} placeholder="Jméno * "/> 
                        </Col>
                        <Col>
                            <Field name="lastName"  type="text" component={renderField} placeholder="Příjmení * " /> 
                        </Col>
                    </Row>
                </Form.Group>

                <Form.Group className="space-bottom">
                    <Field name="email" type="email" component={renderField}  placeholder="Váš e-mail *"/>
                </Form.Group>
                <Form.Group className="space-bottom">
                    <Field name="tel" type="tel" component={renderField}  placeholder="Telefon: např. 111 222 333"/>
                </Form.Group>
                    <Form.Group className="space-bottom" >
                        <Field name="subject" type="text" component={renderField}  placeholder="Předmět e-mailu * "/>
                    </Form.Group>
                    <Form.Group className="small-space-bottom">
                        <Field name="message" type="text" customAS="textarea" customRows={3} component={renderField}  placeholder="Vaše zpráva"/>
                    </Form.Group>
            <Form.Group className="small-space-bottom">
            <CustomCheckBox name="souhlas" feedback="Potvrďte seznámení s podmínkami a informacemi o zpracování údajů." privacyAgreement={true}/>
            </Form.Group>

          
            <Row className="mb-3">

              <Form.Group as={Col} md="8" className="smallest-space-bottom">
              <Field name='captcharesponse' component={Captcha}/>
              </Form.Group>

              <Form.Group as={Col} className="d-flex justify-content-end" md="4" >
                  <button type="submit" disabled={submitting} aria-busy={submitting}
                      style={{ width: '180px', maxWidth: '100%', paddingLeft: '12px', paddingRight: '12px' }} className="rn-button-style--2 btn-solid ">
                      <SubmissionButtonContent submitting={submitting}>Odeslat</SubmissionButtonContent>
                  </button>
              </Form.Group>
            </Row>
        </Form>
    )
}

export default reduxForm({
    form: 'mainContactForm', // a unique identifier for this form
    validate            // <--- validation function given to redux-form
  })(MainContactForm)


